import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import NoRows from '@/components/table/NoRows';
import NotAuthorised from '@/components/errors/NotAuthorised';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import DatasetDictionaryCompact from './DatasetDictionaryCompact';
import DatasetDictionaryFull from './DatasetDictionaryFull';
import { updateDatasetProperties } from '../../actions';
import { showEditDictionary } from '../actions';
import { datasetPerms } from '../../sharing/state/state';
import { canEditDataset } from '../../helper';
import { fetchPmnFunctions } from '../../pmn-functions/actions';

const DatasetDictionary = ({
  allowPmnTransfer,
  canEdit,
  canRead,
  category,
  code,
  compact,
  dictionaries,
  fetchPmnFunctionsData,
  pmnFunctions,
  pmnFunctionsReadStatus,
  saveErrors,
  showDictionaryDialog,
  updateProperties,
}) => {
  useEffect(() => {
    if (canRead && allowPmnTransfer
        && pmnFunctionsReadStatus === states.NONE
        && pmnFunctions.length === 0) {
      fetchPmnFunctionsData('lookups');
    }
  }, []);

  if (!canRead) {
    return <NotAuthorised />;
  }

  return (
    <div className="aridhia-dataset-dictionary">
      <EntitiesErrorMessages
        category={category}
        code={code}
        contexts={['dictionaryUUID', 'fieldUUID']}
        entities={['dictionary', 'dictionaries']}
        entity="dataset"
        errors={saveErrors}
        onDismiss={(errors) => updateProperties(category, code, { saveErrors: errors })}
      />
      {compact && (<DatasetDictionaryCompact category={category} code={code} />)}
      {!compact && (<DatasetDictionaryFull category={category} code={code} />)}
      {dictionaries.length === 0 && (
        <NoRows
          icon="table"
          className="primary"
          entity="dictionary"
          onClick={canEdit ? () => showDictionaryDialog(category, code) : undefined}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({
  auth: { role },
  datasets: { datasets, allowPmnTransfer },
  pmnFunctions: { pmnFunctions },
}, { category, code }) => {
  const dataset = findResult(datasets, category, code) || {
    saveErrors: [],
    dictionaries: [],
    permissions: datasetPerms(),
  };

  return (
    {
      canEdit: canEditDataset(dataset, role),
      canRead: role.permissions.datasets.read,
      allowPmnTransfer,
      dictionaries: dataset.dictionaries,
      pmnFunctions: pmnFunctions.lookups.results,
      pmnFunctionsReadStatus: pmnFunctions.lookups.readStatus || states.NONE,
      saveErrors: dataset.saveErrors,
    }
  );
};

export const mapDispatchToProps = {
  fetchPmnFunctionsData: fetchPmnFunctions,
  showDictionaryDialog: (category, code) => showEditDictionary(category, code, null, true),
  updateProperties: updateDatasetProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetDictionary);
